import { formatMoney } from 'accounting'
import type { ServiceProductModel } from '@models/types'
import type { Row } from '@components/PriceListManager/hooks/usePriceListMatrixItem'

interface RowProps {
  rowData: Row,
  serviceProduct: ServiceProductModel,
}

const ItemRow = (props: RowProps) => {
  const {
    rowData: {
      basePrice, title, optionsTotal, quantity, selectedOptions,
    },
    serviceProduct,
  } = props

  return (
    <tr>
      <td>
        {`${quantity} x ${serviceProduct.title}${title}`}
      </td>

      <td style={{ color: '#8c8c8e', textAlign: 'right' }}>
        {selectedOptions.map((selectedOption, index) => {
          const { value: { price, title } } = selectedOption
          const first = index === 0

          const string = `${title} ${formatMoney(price)}`

          return first ? `${string}` : <><span style={{ color: '#d8d9d9' }}> + </span>{`${string}`}</>
        })}
      </td>

      <td style={{ color: '#8c8c8e', textAlign: 'right' }}>
        {formatMoney(basePrice)}
      </td>

      <td style={{ color: '#8c8c8e', textAlign: 'right' }}>
        {formatMoney(basePrice + optionsTotal)}
      </td>
    </tr>
  )
}

export default ItemRow
